// Concatène des classNames conditionnels — équivalent minimal de `clsx`.
// Évite une dépendance externe pour un usage simple.
export const cn = (...args: Array<string | false | null | undefined>): string =>
  args.filter(Boolean).join(' ')
